import create from "zustand";
import { GetDataRestaurant_API } from "../API/index";

const [useStore] = create((set) => ({
  // actions y states van aqui

  // state
  user: null,
  is_logged: null,
  user_complete: null,


  order_user: [],

  // actions
  saveUser: () => {
    const data = {
      token: localStorage.getItem("token"),
      email: localStorage.getItem("email"),
      localId: localStorage.getItem("localId"),
    };

    set({ user: data });
  },

  handleUserlogged: async () => {
    const user = localStorage.getItem("token");
    const localId = localStorage.getItem("localId");
    try {
      const response = await GetDataRestaurant_API(localId || "");
      set({ user_complete: response.data.data });
    } catch (error) {
      console.error("error al traer usuario");
    }

    if (user) {
      set({ is_logged: true });
      return true;
    } else {
      set({ is_logged: false });
      return false;
    }
  },

  handledLogged: (loged) => {
    set({ is_logged: loged });
  },

  introduce_item: (data) => {
    set((state) => ({
      order_user: [
        data,
        ...state.order_user
      ]
    }));
  },

}));

export default useStore;
